module.exports = __webpack_public_path__ + "img/disable_off_256x256.3a9ff9d7.png";